import { getCurrentTheme } from "@/core/store/app/AppSlice";
import { useAppSelector } from "@/core/store/reduxHooks";
import { InputTextRangeSwiperProps } from "@/types/ui-kit/inputs";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import React from "react";

export const ControlSlider: React.FC<InputTextRangeSwiperProps> = ({
  title,
  leftLabel,
  rightLabel,
  onChange,
  value,
}) => {
  const currentTheme = useAppSelector(getCurrentTheme);

  return (
    <div className="pb-3">
      {title && <div className="mb-1 font-condensed text-md font-light text-dark dark:text-white">{title}</div>}
      <div className="flex items-center justify-between rounded-full bg-gray-100 px-3 py-1.5 dark:bg-white-25">
        {leftLabel && <span className="mr-3 font-mercury text-xs font-semibold dark:text-white">{leftLabel}</span>}
        <Slider
          min={16}
          max={20}
          step={1}
          defaultValue={value}
          trackStyle={currentTheme === "" ? { background: "#000000" } : { background: "#ffffff" }}
          railStyle={currentTheme === "" ? { background: "#CCC9C8" } : { background: "rgba(255, 255, 255, 0.25)" }}
          onChange={onChange}
          handleStyle={{
            width: 20,
            height: 20,
            marginTop: "-8px",
            background: "#fff",
            border: "1px solid #000",
            opacity: 1,
            boxShadow: "0 0 0 0",
          }}
        />
        {rightLabel && <span className="ml-3 font-mercury text-md font-semibold dark:text-white">{rightLabel}</span>}
      </div>
    </div>
  );
};
